export default {
    delete_scheduled_action_title: "Delete Scheduled Action",
    delete_scheduled_actions_title: "Delete Scheduled Actions",
    delete_scheduled_action_message: "Are you sure you want to delete the scheduled action?",
    delete_scheduled_actions_message: "Are you sure you want to delete the scheduled actions?",
    delete_scheduled_action_success_message: "The scheduled action has been deleted",
    delete_scheduled_actions_success_message: "Scheduled actions have been deleted",
    delete_scheduled_action_error_message: "It is not possible to delete the scheduled action",
    delete_scheduled_actions_error_message: "It is not possible to delete scheduled actions",
}